export const locationSvg = {
  d: 'M12,1c-4.97,0-9,4.03-9,9c0,6.75,9,13,9,13s9-6.25,9-13C21,5.03,16.97,1,12,1z M12,13c-1.66,0-3-1.34-3-3s1.34-3,3-3 s3,1.34,3,3S13.66,13,12,13z',
  viewBox: '0 0 24 24',
}

export const caseSvg = {
  d: 'M8 8H6.2002C5.08009 8 4.51962 8 4.0918 8.21799C3.71547 8.40973 3.40973 8.71547 3.21799 9.0918C3 9.51962 3 10.0801 3 11.2002V16.8002C3 17.9203 3 18.4801 3.21799 18.9079C3.40973 19.2842 3.71547 19.5905 4.0918 19.7822C4.5192 20 5.07899 20 6.19691 20H17.8031C18.921 20 19.48 20 19.9074 19.7822C20.2837 19.5905 20.5905 19.2842 20.7822 18.9079C21 18.4805 21 17.9215 21 16.8036V11.1969C21 10.079 21 9.5192 20.7822 9.0918C20.5905 8.71547 20.2837 8.40973 19.9074 8.21799C19.4796 8 18.9203 8 17.8002 8H16M8 8H16M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8',
  strokeWidth: '3',
  viewBox: '-2.4 -2.4 28.80 28.80',
}

export const getValidationError = (errorCode: any) => {
  const codeMatcher: any = {
    ERR_NETWORK: 'Error de conexión. Por favor intente más tarde',
    ERR_FAILED: 'Error de conexión. Por favor intente más tarde',
    ERR_TIMED_OUT: 'Error de conexión. Por favor intente más tarde',
    ERR_CONNECTION_REFUSED: 'Error de conexión. Por favor intente más tarde',
  }

  return codeMatcher[errorCode]
}
